'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-tooltip',
    cnGroup = "".concat(CLASSNAME, "__group"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnBadge = "".concat(CLASSNAME, "__badge"),
    cnBadgeString = "".concat(cnBadge, "--string");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Tooltip(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React__default.createElement("div", {
    className: CLASSNAME
  }, items.map(function (group, index) {
    return /*#__PURE__*/React__default.createElement("ul", {
      className: cnGroup,
      key: index
    }, group.map(function (Item, i) {
      return typeof Item === 'function' && /*#__PURE__*/React__default.isValidElement( /*#__PURE__*/React__default.createElement(Item, null)) ? /*#__PURE__*/React__default.cloneElement( /*#__PURE__*/React__default.createElement(Item, {
        key: i
      }), {
        cnItem: cnItem,
        cnLink: cnLink,
        cnLabel: cnLabel,
        cnGroup: cnGroup
      }) : /*#__PURE__*/React__default.createElement("li", {
        className: cnItem,
        key: Item.title
      }, /*#__PURE__*/React__default.createElement(Link, {
        link: Item.link || '/',
        className: cnLink,
        onClick: Item.onClick,
        "data-type": "tooltip",
        "data-function": "item"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: cnLabel
      }, Item.title), Item.badge && /*#__PURE__*/React__default.createElement("span", {
        className: classNames(cnBadge, _rollupPluginBabelHelpers.defineProperty({}, cnBadgeString, typeof Item.badge === 'string'))
      }, Item.badge)));
    }));
  }));
}
Tooltip.propTypes = {
  /** Array of array of items */
  items: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    link: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired
  })])))
};
Tooltip.defaultProps = {
  items: [[]]
};

module.exports = Tooltip;
